import { createReducer, on } from '@ngrx/store';
import { logins, loginFailure, loginSuccess, logout, enable2FaSuccess, backToPortal, loginLinkAccessSuccess, currentUser, currentUserSuccess, currentUserFailure, applyLoginSuccess } from './authentication.actions';
import { sharedInitialState } from './auth.models';
import { avatarDeletion, avatarDeletionFailure, avatarDeletionSuccess, avatarUpdate, avatarUpdateFailure, avatarUpdateSuccess, profileUpdate, profileUpdateFailure, profileUpdateSuccess } from '../Profile/profile.actions';

export const authenticationReducer = createReducer(

    sharedInitialState,
    on(logins, (state) => ({ ...state, error: null })),
    on(loginSuccess, (state, { user }) => ({ ...state, isLoggedIn: true, user, error: null})),
    on(applyLoginSuccess, (state, { user }) => ({ ...state, user, error: null})),
    on(loginFailure, (state, { error }) => ({ ...state, error })),
    on(enable2FaSuccess, (state) => ({ ...state, 
                                        user: {
                                            ...state.user,
                                            qrcode: null,
                                            two_factor_backup_codes: null,
                                        },
                                    })),

    on(logout, (state) => ({ ...state, user: null })),
    on(backToPortal, (state) => ({ ...state, user: null })),
    
    //Profile Reducer Copies
    on(profileUpdate, (state, {user}) => ({ ...state, user, isProfileUpdated: false })),
    on(profileUpdateSuccess, (state, {user}) => ({ ...state, user, isProfileUpdated: true })),
    on(profileUpdateFailure, (state, { error }) => ({ ...state, error, isProfileUpdated: false })),

    on(avatarUpdate, (state) => ({ ...state, isAvatarProcessing: true})), //No update needed here
    on(avatarUpdateSuccess, (state, { user }) => ({ ...state, user, isAvatarProcessing: false})),
    on(avatarUpdateFailure, (state, { error }) => ({ ...state, error, isAvatarProcessing: false })),

    on(avatarDeletion, (state) => ({ ...state, isAvatarProcessing: true})), //No update needed here
    on(avatarDeletionSuccess, (state, { user }) => ({ ...state, user, isAvatarProcessing: false})),
    on(avatarDeletionFailure, (state, { error }) => ({ ...state, error, isAvatarProcessing: false })),

    //Login Link Access
    on(loginLinkAccessSuccess, (state, { user }) => ({ ...state, isLoggedIn: true, user, error: null })),

    //Fetch logged in user
    on(currentUser, (state) => ({ ...state, loading: true, error: null })),
    on(currentUserSuccess, (state, { user }) => ({ ...state, loading: false, isLoggedIn: true, user, error: null})),
    on(currentUserFailure, (state, { error }) => ({ ...state, loading: false, error })),

);
